import z from 'zod';

import { api } from 'common';
import { Flow } from 'vivaa-api';

export enum HumanTaskAppVariant {
  StaffApp = 'StaffApp',
  CopilotApp = 'CopilotApp',
}

export type HumanTask = api.Flow.HumanTask.HumanTask;

export const HumanTaskState = Flow.HumanTask.HumanTaskState;
export type HumanTaskState = Flow.HumanTask.HumanTaskState;

export import HumanTaskTool = api.FlowDefinition.HumanTaskTool;

export const HumanTaskQueryParamsSchema = z
  .object({
    agentId: z.string(),
    flowId: z.string(),
    organizationId: z.string(),
    categoryId: z.array(z.string()),
    states: z.array(z.nativeEnum(api.Flow.HumanTask.HumanTaskState)).optional(),
    createdByEmail: z.string(),
    searchTerm: z.string(),
    assignedToId: z.string().uuid(),
    q: z.string(),
    sortModel: z.array(
      z.object({
        field: z.string(),
        sort: z.nativeEnum(api.Common.SortOrder),
      })
    ),
  })
  .partial();
